
<p-messages *ngIf="templateWarning" severity="warn">
    <ng-template pTemplate>
        <div>{{templateWarning}}</div>
    </ng-template>
</p-messages>

<div class="grid">
    <div *ngIf="showComunicationType" class="col-12 input-field">
      <label for="caseLogType">Tipo</label>
      <p-dropdown [options]="comunicationTypes" [(ngModel)]="comunicationType" appendTo="body" optionLabel="name" optionValue="code" 
        (onChange)="changeComunicationType($event)"></p-dropdown>
    </div>

    <div *ngIf="comunicationType=='Mail' || comunicationType=='SMS' || comunicationType=='Whatsapp'" class="col-12 input-field">
      <label for="template_id">Plantilla</label>
      <p-dropdown [options]="templates" [(ngModel)]="template_id" optionLabel="name" optionValue="id"  appendTo="body" (onChange)="changeTemplate($event)"></p-dropdown>
    </div>
</div>

  <!-- email -->
  <form [formGroup]="mailFormGroup" *ngIf="mailFormGroup && comunicationType=='Mail'">
    <div class="grid">
      <div class="col-12 input-field">
        <label for="template_id">Desde</label>
        <p-dropdown [options]="mail_accounts" formControlName="mailAccountId" optionLabel="name" optionValue="id"  appendTo="body"></p-dropdown>
      </div>
      <div class="col-12 input-field">
        <label for="tos">Para</label>
        <div class="flex">
          <input pInputText formControlName="tos" d-form-field-error />
          <p-button icon="pi pi-plus" (click)="tos.toggle($event)"></p-button>  
        </div>
        <small id="username-help">
          Añada las direcciones de correos separados por comas.
        </small>
      </div>
      <div class="col-12 input-field">
        <label for="ccs">CC</label>
        <div class="flex">
          <input pInputText formControlName="ccs" d-form-field-error />
          <p-button icon="pi pi-plus" (click)="ccs.toggle($event)"></p-button>  
        </div>
        <small id="username-help">
          Añada las direcciones de correos separados por comas.
        </small>
      </div>
      <div class="col-12 input-field">
        <label for="bccs">CCO</label>
        <div class="flex">
          <input pInputText formControlName="bccs" d-form-field-error />
          <p-button icon="pi pi-plus" (click)="bccs.toggle($event)"></p-button>  
        </div>
        <small id="username-help">
          Añada las direcciones de correos separados por comas.
        </small>
      </div>
      <div class="col-12 input-field">
        <label for="subject">Asunto</label>
        <input pInputText formControlName="subject" d-form-field-error />
      </div>
      <div class="col-12 input-field">
        <label for="content">Email</label>
        <editor [init]="init" formControlName="content" d-form-field-error />
      </div>
    </div>

    <div class="flex" *ngFor="let item of attachments">
      <!--<p-checkbox name="group-{{item.id}}" value="{{item.id}}" formControlName="selectedAttachments" class="checkbox"
        [inputId]="'group-' + item.id"></p-checkbox>-->
      <div class="p-col-fixed">
        <i class="{{getImage(item.contentType)}}" class="p-mt-1"></i>

      </div>
      <div class="p-col">
        <div class="d-flex flex-column">
          <div class="user_name text-truncate">
            <span class="fw-bold card-title"><b>{{item.description}}</b></span>
          </div>
          <small class="emp_post text-muted">{{item.fileName}}</small>
    
        </div>
      </div>
    </div>
</form>

<!-- sms -->
<form [formGroup]="smsFormGroup" *ngIf="smsFormGroup && comunicationType=='SMS'">
  <div class="grid">
    <div class="col-12 input-field">
      <label for="phone">Número de teléfono</label>
      <input pInputText formControlName="phoneNumber" d-form-field-error />
    </div>
    <div class="col-12 input-field">
      <label for="content">Mensaje</label>
      <textarea pInputTextarea formControlName="content" [rows]="5" [maxlength]="maxSmsMessagesLength" d-form-field-error></textarea>
    </div>
    <div class="col-12">
      <small id="username-help">
        Caracteres usados: {{(smsFormGroup.get('content')?.value?.length??'0')}} / {{maxSmsMessagesLength}}
      </small>
    </div>
  </div>
</form>

<!-- whatsapp -->
<form [formGroup]="whatsappFormGroup" *ngIf="whatsappFormGroup && comunicationType=='Whatsapp'">
  <div class="grid">
    <div class="col-12 input-field">
      <label for="phone">Número de teléfono</label>
      <input pInputText formControlName="phoneNumber" d-form-field-error />
    </div>
    <div class="col-12 input-field">
      <label for="content">Mensaje</label>
      <textarea pInputTextarea formControlName="content" d-form-field-error></textarea>
    </div>
  </div>
</form>


<div class="mt-4 flex gap-2 justify-content-end">
  <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
  <p-button label="Enviar" *ngIf="comunicationType=='Mail' && allowWrite" icon="pi pi-send" styleClass="p-ml-2" (click)="saveMail()"></p-button>
  <p-button label="Enviar" *ngIf="comunicationType=='SMS' && allowWrite" icon="pi pi-send" styleClass="p-ml-2" (click)="saveSMS()"></p-button>
  <p-button label="Enviar" *ngIf="comunicationType=='Whatsapp' && allowWrite" icon="pi pi-send" styleClass="p-ml-2" (click)="saveWhatsapp()"></p-button>
</div>
<!-- 
<p-menu #tos [model]="thirdPartyOptions" [popup]="true" appendTo="body">
  <ng-template pTemplate="submenuheader" let-item>
    <span class="text-primary font-bold">{{ item.label }}</span>
  </ng-template>
  <ng-template pTemplate="item" let-item>
      <a pRipple class="flex align-items-center p-menuitem-link">
          <span class="ml-2">{{ item.label }}</span>
      </a>
  </ng-template>

</p-menu>-->
<p-overlayPanel #tos>
  <div>
    <div *ngFor="let item of thirdPartyOptions" class="pb-2">
      <div class="font-bold text-primary mb-2">{{item.label}}</div>
      <div *ngFor="let subItems of item.items" class="mb-2">
        <a class="flex align-items-center p-menuitem-link" (click)="addEmails('tos', subItems.email)" >
          <span class="ml-3">{{ subItems.label }}</span>
        </a>
      </div>

    </div>
  </div>
</p-overlayPanel>

<p-overlayPanel #ccs>
  <div>
    <div *ngFor="let item of thirdPartyOptions" class="pb-2">
      <div class="font-bold text-primary mb-2">{{item.label}}</div>
      <div *ngFor="let subItems of item.items" class="mb-2">
        <a class="flex align-items-center p-menuitem-link" (click)="addEmails('ccs', subItems.email)" >
          <span class="ml-3">{{ subItems.label }}</span>
        </a>
      </div>

    </div>
  </div>
</p-overlayPanel>

<p-overlayPanel #bccs>
  <div>
    <div *ngFor="let item of thirdPartyOptions" class="pb-2">
      <div class="font-bold text-primary mb-2">{{item.label}}</div>
      <div *ngFor="let subItems of item.items" class="mb-2">
        <a class="flex align-items-center p-menuitem-link" (click)="addEmails('bccs', subItems.email)" >
          <span class="ml-3">{{ subItems.label }}</span>
        </a>
      </div>

    </div>
  </div>
</p-overlayPanel>